export default {
    "Data Record": "डेटा रिकॉर्ड",
    "My Storage": "मेरा संचयन",
    "Upgrade": "अपग्रेड",
    "Data Size": "डेटा परिमाण",
    "Folders": "फ़ोल्डर",
    "Files": "फ़ाइलें",
    "Folder Name": "फोल्डर का नाम",
    "Your file is getting upload":"फाइल अपलोड हो रही है",
    "Rename Folder": "फ़ोल्डर का नाम बदलें",
    "Move Folder": "फ़ोल्डर मूव करें",
    "Delete Folder": "फोल्डर डिलीट करें",
    "Upload": "अपलोड",
    "Create Folder": "फोल्डर बनाएं",
    "Uploading": "अपलोड हो रहा है",
    "Cancel Uploading": "अपलोड करना रद्द करें",
    "Are you sure want to cancel ?": "क्या आप रदद करना चाहते हैं?",
    "Yes": "हाँ",
    "No": "नहीं",
    "Are you sure want to delete ?": "क्या आप डिलीट करना चाहते हैं?",
    "Cancel": "रद्द करना",
    "Delete": "डिलीट",
    "Rename Folder/File": "फ़ोल्डर/फ़ाइल का नाम बदलें",
    "Folder  Name / File Name": "फ़ोल्डर का नाम/फ़ाइल का नाम",
    "Save": "सेव",
    "Move File": "फ़ाइल मूव करें",
    "Move": "मूव",
    "Share": "शेयर",
    "Rename": "नाम बदलें",
    "Delete": "डिलीट",
    "Download": "डाउनलोड",
    "No Data Found":"कोई डेटा नहीं मिला",
    "uploaded successfully": "अपलोड हो गया",
    "You can share one file at a time":"आप एक समय में एक फ़ाइल शेयर कर सकते हैं",
    "Choose your folder and click on move here": "फ़ोल्डर चुनें और मूव फाइल पर क्लिक करें",
    "You can download one file at time": "आप एक समय पर एक फ़ाइल डाउनलोड कर सकते हैं",
    "you can rename one file at a time": "आप एक बार में एक फ़ाइल का नाम बदल सकते हैं",
    "Rename successfull": "नाम बदल दिया गया",
    "file Deleted Successfully": "फ़ाइल डिलीट कर दी गई",
    "Search": "खोज...",
    "Load More": "और लोड करें",
    "No more Data": "और डेटा नहीं है",
    "Insufficient Memory": "आपके पास पर्याप्त जगह नहीं है"
}